import _ from 'lodash';

import consts from '../../../consts';
import context from '../../../context';
import langs from '../../../localization/langs';
import services from '../../../services';
import useMenuItem from '../../AGTable/hooks/useMenuItem';

export default function useContinuousDeliveryMenuItem(onChange = _.noop) {
  const notifications = context.Notifications.useNotifications();

  async function onConfirm(tenant) {
    try {
      await services.tenants.updateById(tenant.tenantId, {isCdEnabled: !tenant.isCdEnabled});
      onChange();
    } catch (error) {
      notifications.error(langs('ERROR_UPDATE_CONTINUOUS_DELIVERY'));
    }
  }

  function getName(tenant) {
    return tenant.isCdEnabled
      ? langs('BUTTON_CONTINUOUS_DELIVERY_DISABLE')
      : langs('BUTTON_CONTINUOUS_DELIVERY_ENABLE');
  }

  const user = context.User.useUser();

  return useMenuItem(
    onConfirm,
    getName,
    'baseline_rocket_launch_white_24dp',
    consts.rbac.permissions.maestro.tenant.edit.isCdEnabled,
    user.rbac.maestro
  );
}
